import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'vex-yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.scss']
})
export class YesNoComponent implements OnInit {
  title: string;
  message: string;
  no: string = "No";
  yes :string = "Yes";
  titleImg: boolean = false;
  titleClr: string = "";
  cancelBtn: boolean = false;
  proceedBtn : boolean = false;
  titleImgPath : string;
  noCancelBtn : boolean = true;
  constructor(public dialogRef: MatDialogRef<YesNoComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private sanitizer: DomSanitizer) {
              }

  ngOnInit() {
  }

  close(action) {
    this.dialogRef.close({ status: action });
  }
}
